export default {
  SpecialSupervision: 1,
  Mehadrin: 2,
  Rabbanut: 3,
  MehadrinAndRabbanut: 5,
};
